// Back-office building blocks, in the Flow B prototype's language (design/Flow B - Events Team.dc.html):
// bordered stat grids, Clash Display numerals and titles, pill filters, dense grid tables.
import React from "react";

export const fmtWhen = (d) => d ? new Date(d).toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "";

export function StatStrip({ items, big }) {
  return (
    <div className={`bo-stats ${big ? "big" : ""}`}>
      {items.map(s => (
        <div className="bo-stat" key={s.k}>
          <div className="k">{s.k}</div>
          <div className="v" style={s.color ? { color: s.color } : undefined}>{s.v}</div>
          {s.sub && <div className="sub">{s.sub}</div>}
        </div>
      ))}
    </div>
  );
}

export function FilterRow({ label, options, value, onChange }) {
  return (
    <div className="bo-filter-row">
      <div className="lbl">{label}</div>
      {options.map(o => (
        <button key={o.value} type="button" className={`bo-pill ${value === o.value ? "on" : ""} ${o.tone ?? ""}`} onClick={() => onChange(o.value)}>
          {o.label} {o.count !== undefined && <span className="n">{o.count}</span>}
        </button>
      ))}
    </div>
  );
}

export function PageHead({ title, sub, aside }) {
  return (
    <div className="bo-pagehead">
      <div><h1 className="bo-title">{title}</h1>{sub && <div className="bo-sub">{sub}</div>}</div>
      {aside}
    </div>
  );
}

export function StatePill({ state }) {
  const tone = { registered: "ok", bounced: "bad", revoked: "bad", opened: "mid", sent: "mid", used: "ok" }[state] ?? "";
  const label = { used: "Booked", received: "Not booked" }[state] ?? state;
  return <span className={`bo-state ${tone}`}>{label}</span>;
}

export function Notice({ tone = "info", children }) {
  return <div className={`bo-notice ${tone}`}>{children}</div>;
}
